import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
export default class LeaderboardState {
  constructor() {
    _defineProperty(this, "podiumEntries", []);
    _defineProperty(this, "contenderEntries", []);
    _defineProperty(this, "honorableEntries", []);
    _defineProperty(this, "podiumLoading", false);
    _defineProperty(this, "contendersLoading", false);
    _defineProperty(this, "honorableLoading", false);
    _defineProperty(this, "loadingMore", false);
    _defineProperty(this, "period", 'all');
    _defineProperty(this, "honorableOffset", 0);
    _defineProperty(this, "hasMore", false);
  }
  async load(period) {
    this.period = period;
    this.honorableOffset = 0;
    this.podiumEntries = [];
    this.contenderEntries = [];
    this.honorableEntries = [];
    this.podiumLoading = true;
    this.contendersLoading = true;
    this.honorableLoading = true;
    this.hasMore = false;
    m.redraw();
    await Promise.all([this.fetchPodium(), this.fetchContenders(), this.fetchHonorable(false)]);
  }
  async loadMore() {
    if (!this.hasMore || this.loadingMore) return;
    this.loadingMore = true;
    m.redraw();
    await this.fetchHonorable(true);
  }
  async fetchPodium() {
    try {
      const results = await app.store.find('leaderboard-entries', {
        include: 'user',
        filter: {
          period: this.period,
          section: 'podium'
        }
      });
      this.podiumEntries = Array.isArray(results) ? results : [results];
    } catch (e) {
      // Error handled by Flarum
    } finally {
      this.podiumLoading = false;
      m.redraw();
    }
  }
  async fetchContenders() {
    try {
      const results = await app.store.find('leaderboard-entries', {
        include: 'user',
        filter: {
          period: this.period,
          section: 'contenders'
        }
      });
      this.contenderEntries = Array.isArray(results) ? results : [results];
    } catch (e) {
      // Error handled by Flarum
    } finally {
      this.contendersLoading = false;
      m.redraw();
    }
  }
  async fetchHonorable(append) {
    try {
      const results = await app.store.find('leaderboard-entries', {
        include: 'user',
        filter: {
          period: this.period,
          section: 'honorable'
        },
        page: {
          offset: this.honorableOffset,
          limit: 20
        }
      });
      const payload = results.payload;
      const newEntries = Array.isArray(results) ? results : [results];
      if (append) {
        this.honorableEntries = [...this.honorableEntries, ...newEntries];
      } else {
        this.honorableEntries = newEntries;
      }
      this.honorableOffset += newEntries.length;

      // JSON:API standard: if there's a "next" link, there are more results
      this.hasMore = !!payload?.links?.next;
    } catch (e) {
      // Error handled by Flarum
    } finally {
      this.honorableLoading = false;
      this.loadingMore = false;
      m.redraw();
    }
  }
  get isFullyLoaded() {
    return !this.podiumLoading && !this.contendersLoading && !this.honorableLoading;
  }
  get isEmpty() {
    return this.isFullyLoaded && this.podiumEntries.length === 0 && this.contenderEntries.length === 0 && this.honorableEntries.length === 0;
  }
}
flarum.reg.add('huseyinfiliz-leaderboard', 'forum/utils/LeaderboardState', LeaderboardState);